import { FC } from 'react';
import { useSelector } from 'react-redux';
import CurrencyPrice from '../../../../../common/currency-price/currency-price';
import ReferralPromoFlag from '../../../../../common/referral-promo-flag/referral-promo-flag';
import cn from '../../../../../utils/classnames';
import isSaleAllowed from '../../../../../utils/material/is-sale-allowed';

type CartItemPriceProps = { item: CartItem };

const CartItemPrice: FC<CartItemPriceProps> = (props) => {
    const { item } = props;

    const cart = useSelector((state: RootState) => state.main.cart);
    const user = useSelector((state: RootState) => state.main.user);
    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);

    if (!(user.loaded && cart.loaded)) {
        return null;
    }

    const { finalPrice, originalPrice, material } = item;
    const isMaterialOnSale = Boolean(material.sale) && isSaleAllowed(material, countryCode);
    const isMaterialDiscountedByPromo = cart.promo?.applied === material.id;

    let materialOriginalPrice;

    if (isMaterialDiscountedByPromo) {
        materialOriginalPrice = originalPrice;
    } else if (isMaterialOnSale) {
        materialOriginalPrice = material.sale?.original_price;
    }

    return (
        <div className='price-section'>
            <div className='d-flex flex-column'>
                <span className={cn('digits tsc-body-highlighted', { 'price-highlighted': materialOriginalPrice })}>
                    <CurrencyPrice price={finalPrice} />
                </span>
                {materialOriginalPrice && (
                    <span className='strike-through tsc-caption before-sale-price'>
                        <CurrencyPrice price={materialOriginalPrice} />
                    </span>
                )}
            </div>
            {isMaterialDiscountedByPromo && <ReferralPromoFlag />}
        </div>
    );
};

export default CartItemPrice;
